import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import {selectActiveVehicle, selectProfile} from '@ox/data';
import {RecallsVehicle} from '@ox/typings';
import {AutoDestroy} from '@ox/utils';
import {Subject, takeUntil, tap, map, merge} from 'rxjs';
import {RecallsPageService} from '@ox/recalls';

const UPDATE = 'ma_recalls_mileage_update';
const CANCEL = 'ma_recalls_mileage_cancel';
type update = typeof UPDATE;
type cancel = typeof CANCEL;
type labelState = update | cancel;

@Component({
  selector: 'webu-warranty-mileage',
  templateUrl: './warranty-mileage.component.html'
})
export class WarrantyMileageComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  odometerAttributes = this.recallsPage.odometerAttr;
  public refreshDate = this.recallsPage.getCurrentDate;
  public updateOdometerError$ = this.recallsPage.odometerUpdateError$;
  public warrantyError$ = this.recallsPage.warrantyError$;
  public updateMileageButtonLabel: labelState = UPDATE;
  public invalidDate = -1;
  public mileageUpdateForm: FormGroup;
  public updateMilesInputToggle = false;
  private activeVehicle$ = this.store.select(selectActiveVehicle);
  private warrantyVehicle$ = this.recallsPage.recallsVehicle$;

  public auth$ = this.store
    .select(selectProfile)
    .pipe(map((profile) => !!profile));

  constructor(
    private fb: FormBuilder,
    private store: Store,
    private recallsPage: RecallsPageService
  ) {
    merge(this.warrantyVehicle$, this.activeVehicle$)
      .pipe(
        takeUntil(this.destroy$),
        tap((vehicle) => {
          if (vehicle) {
            this.updateMilesInputToggle = false;
            this.warrantyVehicle = vehicle;
          }
        })
      ).subscribe();
  }

  private _warrantyVehicle: RecallsVehicle;

  get warrantyVehicle(): RecallsVehicle {
    return this._warrantyVehicle;
  }

  set warrantyVehicle(vehicle: RecallsVehicle) {
    this._warrantyVehicle = vehicle;
  }

  get odometer() {
    return this.warrantyVehicle.odometer ? this.warrantyVehicle.odometer : '0';
  }

  get mileageLabel() {
    return this.updateMilesInputToggle ? CANCEL : UPDATE;
  }

  ngOnInit(): void {
    this.initUpdateMileageForm();
  }

  public toggleMilesDisplayInput() {
    this.mileageUpdateForm.reset();
    if (this._warrantyVehicle && this.odometer) this.mileageUpdateForm.setValue({mileageInput: this.odometer});
    this.updateMilesInputToggle = !this.updateMilesInputToggle;
    this.updateMileageButtonLabel = this.updateMilesInputToggle ? CANCEL : UPDATE;
  }

  public updateMileageSave(mileageInput: { [key: string]: string }) {
    if (this.mileageUpdateForm?.valid)
      this.recallsPage.odometerUpdate = mileageInput['mileageInput'];

    this.updateMilesInputToggle = false;
  }

  private initUpdateMileageForm() {
    if (this.odometerAttributes?.maxlength && this.odometerAttributes?.pattern) {
      this.mileageUpdateForm = this.fb.group({
        mileageInput: new FormControl(0, [
          Validators.maxLength(this.odometerAttributes.maxlength),
          Validators.required,
          Validators.pattern(this.odometerAttributes.pattern)
        ])
      });
    }
  }
}
